if (!customElements.get("td-select-tabs")) {
  class TdSelectTabs extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.TRIGGERS = this.querySelectorAll('[data-id]');
      this.activeTabs = this.querySelectorAll('.__tabs-tab.td-active');
      this.activeTabContent = document.querySelector(`#${this.activeTabs[0]?.dataset?.id}`);
      this.SELECT_WRAPPER = this.querySelector('[data-select-wrapper]');
      this.SELECT_TRIGGER = this.querySelector('[data-select-trigger]');
      this.SELECT_TEXT = this.querySelector('[data-select-text]');
      this.SELECT_DD = this.querySelector('[data-select-dd]');
      if (!this.activeTabContent || !this.SELECT_WRAPPER || !this.SELECT_TRIGGER || !this.SELECT_TEXT || !this.SELECT_DD) {
        return
      }

      this.setActiveTab(this.activeTabs[0]);
      this.attachListeners();
    }

    attachListeners() {
      this.TRIGGERS.forEach((trigger) => {
        trigger.addEventListener('click', () => {
          this.setActiveTab(trigger);
        })
      });
      this.SELECT_TRIGGER.addEventListener('click', () => {
        this.toggleSelect();
      });
      window.addEventListener("click", (e) => {
        const selectIsClicked = this.SELECT_TRIGGER.contains(e.target);
        if (!selectIsClicked) {
          this.toggleSelect(true);
        }
      });
    }

    setActiveTab(trigger) {
      this.activeTabs.forEach((tab) => {
        tab.classList.remove('td-active');
      });
      this.activeTabs = this.querySelectorAll(`[data-id="${trigger?.dataset?.id}"]`);
      this.activeTabs.forEach((tab) => {
        tab.classList.add('td-active');
      });
      this.activeTabContent.classList.remove('td-active');
      this.activeTabContent = document.querySelector(`#${trigger?.dataset?.id}`);
      this.activeTabContent.classList.add('td-active');
      this.SELECT_TEXT.innerHTML = trigger.innerHTML;
    }

    toggleSelect(dismiss = false) {
      if (dismiss) {
        this.SELECT_WRAPPER.classList.remove('td-active');
        return;
      } else {
        this.SELECT_WRAPPER.classList.toggle('td-active');
      }
    }

  }

  customElements.define("td-select-tabs", TdSelectTabs);
}
